import { CONSTANTS } from './../../Constants/Constants';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class LoadingSpinnerService {
  private activeRequestCount = 0;
  private manualSpinnerCount = 0;
  public currentMessage: string = '';

  constructor(private readonly spinner: NgxSpinnerService) { }

  beginRequest(spinnerName: string = CONSTANTS.DASHBOARD_SPINNER): void {
    if (this.isCustomSpinner(spinnerName)) {
      this.spinner.show(spinnerName);
      return;
    }

    const previousTotal = this.getTotalDefaultSpinnerCount();
    this.activeRequestCount += 1;

    if (previousTotal === 0) {
      this.spinner.show(CONSTANTS.DASHBOARD_SPINNER);
    }
  }

  endRequest(spinnerName: string = CONSTANTS.DASHBOARD_SPINNER): void {
    if (this.isCustomSpinner(spinnerName)) {
      this.spinner.hide(spinnerName);
      return;
    }

    const previousTotal = this.getTotalDefaultSpinnerCount();
    this.activeRequestCount = Math.max(0, this.activeRequestCount - 1);

    if (previousTotal > 0 && this.getTotalDefaultSpinnerCount() === 0) {
      this.spinner.hide(CONSTANTS.DASHBOARD_SPINNER);
    }
  }

  show(spinnerName: string = CONSTANTS.DASHBOARD_SPINNER): void {
    if (this.isCustomSpinner(spinnerName)) {
      this.spinner.show(spinnerName);
      return;
    }

    const previousTotal = this.getTotalDefaultSpinnerCount();
    this.manualSpinnerCount += 1;

    if (previousTotal === 0) {
      this.spinner.show(CONSTANTS.DASHBOARD_SPINNER);
    }
  }

  hide(spinnerName: string = CONSTANTS.DASHBOARD_SPINNER): void {
    if (this.isCustomSpinner(spinnerName)) {
      this.spinner.hide(spinnerName);
      return;
    }

    const previousTotal = this.getTotalDefaultSpinnerCount();
    this.manualSpinnerCount = Math.max(0, this.manualSpinnerCount - 1);

    if (previousTotal > 0 && this.getTotalDefaultSpinnerCount() === 0) {
      this.spinner.hide(CONSTANTS.DASHBOARD_SPINNER);
    }
  }

  private getTotalDefaultSpinnerCount(): number {
    return this.activeRequestCount + this.manualSpinnerCount;
  }

  private isCustomSpinner(spinnerName: string): boolean {
    return Boolean(spinnerName) && spinnerName !== CONSTANTS.DASHBOARD_SPINNER;
  }

  updateMessage(message: string): void {
    this.currentMessage = message;
  }
}